import {
    VOTING_GET_MY_VOTING_SESSIONS,
    VOTING_DELETE_MY_VOTING_SESSION,
    VOTING_ADDNEW_VOTING_SESSION,
    VOTING_UPDATE_VOTING_SESSION,
    VOTING_REINDEX_SESSION,

    VOTING_GET_ALL_MY_VOTING_CATEGORIES,
    VOTING_DELETE_MY_VOTING_CATEGORY,
    VOTING_ADDNEW_VOTING_CATEGORY,
    VOTING_UPDATE_VOTING_CATEGORY,

    VOTING_GET_MY_VOTING_PARTICIPANTS,
    VOTING_DELETE_MY_VOTING_PARTICIPANT,
    VOTING_ADDNEW_VOTING_PARTICIPANT,
    VOTING_UPDATE_VOTING_PARTICIPANT,
    VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT,

    VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE,
    VOTING_TOPUP_VOTES_TO_PARTICIPANT,
    VOTING_DUPLICATE_SESSION,
    VOTING_GET_VOTING_SESSIONS,

    // Nomination actions
    VOTING_GET_SESSION_NOMINEES,
    VOTING_UPDATE_NOMINEE_STATUS,
    VOTING_MOVE_NOMINEE_TO_PARTICIPANT,
    VOTING_DELETE_NOMINEE,

    // Participant Rewards actions
    VOTING_GET_PARTICIPANT_REWARDS_HISTORY,
    VOTING_ADD_PARTICIPANT_REWARD,
    VOTING_UPDATE_PARTICIPANT_REWARD,
    VOTING_DELETE_PARTICIPANT_REWARD,

    // Manual votes action
    VOTING_ADD_VOTES_MANUALLY,
    VOTING_GET_ADDED_VOTES_HISTORY,

    // Participant actions
    PARTICIPANT_LOGIN,
    PARTICIPANT_GET_DASHBOARD,
    PARTICIPANT_UPDATE_PROFILE,
    PARTICIPANT_LOGOUT,
    PARTICIPANT_GET_TRANSACTIONS,
    PARTICIPANT_GET_INVOICES,
    PARTICIPANT_GET_INVOICE,
    PARTICIPANT_CREATE_INVOICE,
    PARTICIPANT_UPDATE_INVOICE,
    PARTICIPANT_DELETE_INVOICE
} from "../actions/voting";

import {
    API_BASE_URL,
    VOTING_GET_MY_VOTING_SESSIONS_URL,
    VOTING_DELETE_MY_VOTING_SESSION_URL,
    VOTING_ADDNEW_VOTING_SESSION_URL,
    VOTING_UPDATE_VOTING_SESSION_URL,
    VOTING_REINDEX_SESSION_URL,

    VOTING_GET_ALL_MY_VOTING_CATEGORIES_URL,
    VOTING_DELETE_MY_VOTING_CATEGORY_URL,
    VOTING_ADDNEW_VOTING_CATEGORY_URL,
    VOTING_UPDATE_VOTING_CATEGORY_URL,

    VOTING_GET_MY_VOTING_PARTICIPANTS_URL,
    VOTING_DELETE_MY_VOTING_PARTICIPANT_URL,
    VOTING_ADDNEW_VOTING_PARTICIPANT_URL,
    VOTING_UPDATE_VOTING_PARTICIPANT_URL,
    VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT_URL,

    VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE_URL,
    VOTING_TOPUP_VOTES_TO_PARTICIPANT_URL,
    VOTING_DUPLICATE_SESSION_URL,
    VOTING_GET_VOTING_SESSIONS_URL,

    // Nomination URLs
    VOTING_GET_SESSION_NOMINEES_URL,
    VOTING_UPDATE_NOMINEE_STATUS_URL,
    VOTING_MOVE_NOMINEE_TO_PARTICIPANT_URL,
    VOTING_DELETE_NOMINEE_URL,

    // Participant Rewards URLs
    VOTING_GET_PARTICIPANT_REWARDS_HISTORY_URL,
    VOTING_ADD_PARTICIPANT_REWARD_URL,
    VOTING_UPDATE_PARTICIPANT_REWARD_URL,
    VOTING_DELETE_PARTICIPANT_REWARD_URL,

    // Manual votes URL
    VOTING_ADD_VOTES_MANUALLY_URL,
    VOTING_GET_ADDED_VOTES_HISTORY_URL,

    // Participant URLs
    PARTICIPANT_LOGIN_URL,
    PARTICIPANT_GET_DASHBOARD_URL,
    PARTICIPANT_UPDATE_PROFILE_URL,
    PARTICIPANT_LOGOUT_URL,
    PARTICIPANT_GET_TRANSACTIONS_URL,
    PARTICIPANT_GET_INVOICES_URL,
    PARTICIPANT_GET_INVOICE_URL,
    PARTICIPANT_CREATE_INVOICE_URL,
    PARTICIPANT_UPDATE_INVOICE_URL,
    PARTICIPANT_DELETE_INVOICE_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [VOTING_DUPLICATE_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DUPLICATE_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_VOTING_SESSIONS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_VOTING_SESSIONS_URL,
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_TOPUP_VOTES_TO_PARTICIPANT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_TOPUP_VOTES_TO_PARTICIPANT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_REINDEX_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_REINDEX_SESSION_URL + "/" + payload.id,
            method: "GET",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_ALL_MY_VOTING_CATEGORIES]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_ALL_MY_VOTING_CATEGORIES_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_DELETE_MY_VOTING_CATEGORY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DELETE_MY_VOTING_CATEGORY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_ADDNEW_VOTING_CATEGORY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_ADDNEW_VOTING_CATEGORY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_UPDATE_VOTING_CATEGORY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_UPDATE_VOTING_CATEGORY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_MY_VOTING_PARTICIPANTS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_MY_VOTING_PARTICIPANTS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_DELETE_MY_VOTING_PARTICIPANT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DELETE_MY_VOTING_PARTICIPANT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_ADDNEW_VOTING_PARTICIPANT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_ADDNEW_VOTING_PARTICIPANT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_UPDATE_VOTING_PARTICIPANT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_UPDATE_VOTING_PARTICIPANT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },


    [VOTING_GET_MY_VOTING_SESSIONS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_MY_VOTING_SESSIONS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_DELETE_MY_VOTING_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DELETE_MY_VOTING_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_ADDNEW_VOTING_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_ADDNEW_VOTING_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_UPDATE_VOTING_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_UPDATE_VOTING_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    // Nomination actions

    [VOTING_GET_SESSION_NOMINEES]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_SESSION_NOMINEES_URL,
            method: "GET",
            params: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    [VOTING_UPDATE_NOMINEE_STATUS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_UPDATE_NOMINEE_STATUS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    [VOTING_MOVE_NOMINEE_TO_PARTICIPANT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_MOVE_NOMINEE_TO_PARTICIPANT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    [VOTING_DELETE_NOMINEE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DELETE_NOMINEE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    // Participant Rewards actions
    [VOTING_GET_PARTICIPANT_REWARDS_HISTORY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_PARTICIPANT_REWARDS_HISTORY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_ADD_PARTICIPANT_REWARD]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_ADD_PARTICIPANT_REWARD_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_UPDATE_PARTICIPANT_REWARD]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_UPDATE_PARTICIPANT_REWARD_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_DELETE_PARTICIPANT_REWARD]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_DELETE_PARTICIPANT_REWARD_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    // Manual votes action
    [VOTING_ADD_VOTES_MANUALLY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_ADD_VOTES_MANUALLY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [VOTING_GET_ADDED_VOTES_HISTORY]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + VOTING_GET_ADDED_VOTES_HISTORY_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    // Participant actions
    [PARTICIPANT_LOGIN]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_LOGIN_URL,
            method: "POST",
            data: payload
        });
    },
    [PARTICIPANT_GET_DASHBOARD]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_GET_DASHBOARD_URL,
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_UPDATE_PROFILE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_UPDATE_PROFILE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_LOGOUT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_LOGOUT_URL,
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_GET_TRANSACTIONS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_GET_TRANSACTIONS_URL,
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_GET_INVOICES]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_GET_INVOICES_URL,
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_GET_INVOICE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_GET_INVOICE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_CREATE_INVOICE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_CREATE_INVOICE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_UPDATE_INVOICE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_UPDATE_INVOICE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PARTICIPANT_DELETE_INVOICE]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PARTICIPANT_DELETE_INVOICE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};
